import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@material-ui/core';
import GoalHexagonChevron from 'Assets/Images/goal-polygon-chevron.svg';
import GoalHexagon from 'Assets/Images/goal-polygon.svg';
import { displayErrorMessage, displaySuccess } from 'Helpers/FacetNotificationManager';
import { makeStyles } from '@material-ui/core/styles';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';

const useStyles = makeStyles(() => ({
  chevronButton: {
    width: '18px',
    height: '15px',
  },
}));

const BestNextStepCheckbox = ({ goalResource, updateGoalCollection }) => {
  const {
    rootNodeProps,
    logResourceEventSuccess,
    logResourceEventFailureWithError,
  } = useEventTrackingLogEvent({ nodeName: 'Goal Best Next Step Checkbox' });
  const classes = useStyles();
  const bestNextStep = goalResource.attr('bestNextStep') === 'true';


  const toggleBestNextStep = async (e) => {
    e.stopPropagation();
    try {
      await goalResource.attr('bestNextStep', !bestNextStep).submit();
      displaySuccess('Successfully set Best Next Step');
      logResourceEventSuccess('Toggled Best Next Step on Goal', goalResource, {
        bestNextStep: !bestNextStep,
      });
      updateGoalCollection();
    } catch (err) {
      displayErrorMessage(err, 'Could not set Best Next Step');
      logResourceEventFailureWithError('Toggled Best Next Step on Goal', goalResource, err, {
        bestNextStep: !bestNextStep,
      });
    }
  };

  return !goalResource.id() ? null : (
    <Tooltip title="Best Next Step" placement="top" arrow>
      <IconButton {...rootNodeProps} className={classes.chevronButton} size="small" onClick={toggleBestNextStep}>
        <img src={bestNextStep ? GoalHexagonChevron : GoalHexagon} alt="chevron" />
      </IconButton>
    </Tooltip>);
};

BestNextStepCheckbox.propTypes = {
  goalResource: PropTypes.object.isRequired,
  updateGoalCollection: PropTypes.func.isRequired,
};

export default BestNextStepCheckbox;
